<!-- <p-dialog *transloco="let t;" header="Header" [(visible)]="visible" [breakpoints]="{ '1080px': '75vw', '560px':'90vw' }" [style]="{ width: '50vw' }" (onHide)="onHide()" class="packages-modal migrate-modal" [modal]="true" [dismissableMask]="true"> -->
<div class="migrate-modal w-min">


  <ng-template pTemplate="header">
    <span class="text-xl font-bold text-white"></span>
  </ng-template>
  <div class="flex flex-wrap gap-3">
    <div class="tcg-header">
      <h1>Select type of migration:</h1>
      <div class="migrate-type-container" *ngIf="startingMon">
        <div class="migrate-type-item" *ngIf="startingMon.isStarter" [ngClass]="{'selected': migrationType[0]}"
          (click)="selectMigrationType(0)">
          overwrite
        </div>
        <div class="migrate-type-item" [ngClass]="{'selected': migrationType[1]}" (click)="selectMigrationType(1)">
          merge
        </div>
        <div class="price-tag-container" *ngIf="startingMon.isStarter && migrationType[0]">
          <span>Free</span>
        </div>
        <div class="price-tag-container" *ngIf="(startingMon.isStarter && migrationType[1]) || !startingMon.isStarter">
          <span>{{kmonPrice}} <img src="./assets/img/Icon/Cur-Kmon.png"></span>
          <div class="divider"></div>
          <span>{{usdPrice}}$</span>
        </div>
      </div>
    </div>
    <div class="kryptomon-block">
      <div class="two-cards-container">
        <k-kryptomon-card [data]="startingMon" *ngIf="startingMon"></k-kryptomon-card>
        <div class="arrow-effect">
          <img src="./assets/img/Icon/Lens-Flare-Rays-3.png" />
          <img src="./assets/img/Icon/Arrow.png" *ngIf="!migrateSuccess" class="arrow_rotate" />
          <img src="./assets/img/Icon/check-mark.png" *ngIf="migrateSuccess" />
        </div>
        <!--<k-kryptomon-card></k-kryptomon-card>-->
        <div class="empty-select-card" (click)="selectorToggle()" *ngIf="!selectedMon">
          <img src="./assets/img/Icon/Add.png" />
          <p>Select your Kryptomon which you want to migrate to</p>
        </div>
        <k-kryptomon-card [data]="selectedMon" *ngIf="selectedMon" (click)="selectorToggle()"
          class="second-mon-card"></k-kryptomon-card>
      </div>
      <div class="select-kryptomon-container" *ngIf="showSelector">
        <div class="select-kryptomon-container-scroller" id="select-kryptomon-container-scroller" horizontal-scroll>
          <k-kryptomon-card *ngFor="let mon of allMons; let i = index" (click)="selectMon(i)"
            [data]="mon"></k-kryptomon-card>
        </div>
      </div>
      <div class="training-infos-block" *ngIf="selectedMon && !showSelector && !migrateSuccess">
        <div class="training-info-container">
          <div class="training-info-item">
            <span>Main Element</span>
            <span>{{startingMon.gameMetadata.mainFamilyTalentLevel}}/50</span>
          </div>
          <div class="training-info-item">
            <span>Secondary Element</span>
            <span>{{startingMon.gameMetadata.secondaryFamilyTalentLevel}}/50</span>
          </div>
          <div class="training-info-item">
            <span>Stamina</span>
            <span>{{startingMon.gameMetadata.hpLevel}}/50</span>
          </div>
          <div class="training-info-item">
            <span>Attack</span>
            <span>{{startingMon.gameMetadata.attackLevel}}/50</span>
          </div>
          <div class="training-info-item">
            <span>Resistance</span>
            <span>{{startingMon.gameMetadata.defenseLevel}}/50</span>
          </div>
        </div>
        <div class="training-info-container chart">
          <p-chart type="bar" #chart [data]="basicData" [options]="basicOptions"></p-chart>
          <div class="label-container">
            <div class="label-item">
              <div class="label-title">
                Main Element
              </div>
              <div class="label-values">
                <p>{{finalDataSetClean[0]}}/50</p>
                <p>{{selectedMon.gameMetadata.mainFamilyTalentLevel}}/50</p>
              </div>
            </div>
            <div class="label-item">
              <div class="label-title">
                Secondary Element
              </div>
              <div class="label-values">
                <p>{{finalDataSetClean[1]}}/50</p>
                <p>{{selectedMon.gameMetadata.secondaryFamilyTalentLevel}}/50</p>
              </div>
            </div>
            <div class="label-item">
              <div class="label-title">
                Stamina
              </div>
              <div class="label-values">
                <p>{{finalDataSetClean[2]}}/50</p>
                <p>{{selectedMon.gameMetadata.hpLevel}}/50</p>
              </div>
            </div>
            <div class="label-item">
              <div class="label-title">
                Attack
              </div>
              <div class="label-values">
                <p>{{finalDataSetClean[3]}}/50</p>
                <p>{{selectedMon.gameMetadata.attackLevel}}/50</p>
              </div>
            </div>
            <div class="label-item">
              <div class="label-title">
                Resistance
              </div>
              <div class="label-values">
                <p>{{finalDataSetClean[4]}}/50</p>
                <p>{{selectedMon.gameMetadata.defenseLevel}}/50</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="warning-banner" *ngIf="selectedMon && !showSelector && startingMon.isStarter">
        <p>Warning</p>
        <p>This Syntethic Kryptomon will be destroyed once the migration has been completed.</p>
      </div>
      <div class="action-buttons" *ngIf="selectedMon && !showSelector">
        <k-button buttonStyle="gradient" (click)="balanceChecker()" [label]="'Migrate'"
          *ngIf="!migrateSuccess"></k-button>
        <k-button buttonStyle="gradient" (click)="openMigrated()" [label]="'Go to Kryptomon'"
          *ngIf="migrateSuccess && migrateNft"></k-button>
      </div>
    </div>
  </div>
</div>
<!-- </p-dialog> -->
<!-- <package-buy-modal [visible]="isPackageModalOpened" (isVisible)="isPackageModalOpened=$event" [wallet]="'WalletTEST'"></package-buy-modal> -->